import Vue from 'vue'
import Router from 'vue-router'
import home from '../views/home'
import index from '../views/index/index'
import buySucess from '../views/curriculum/buySucess'
//密码修改页面
import resPassword from '../components/content/resPassword'
//密码修改成功页面
// import resSucess from '../components/content/resSucess'
//设置页面
import personSet from '../views/personSet/personSet'
import contactUs from '../views/public/ContactUs'
import error from '../views/public/Error'
//课程
import curriculum from '../views/curriculum/curriculum'
//考试开始页面,结课测试
import exam_begins from '../views/exam/examBegins'
//考试页面
import testPage from "../views/testPage/testPage"
//注册成功发送邮件
import register_email from '../views/index/register_email'
//课程播放(视频课程/阅读课程)
import curriculum_lesson from '../views/curriculum/lesson'
//作业界面
import task_answer from '../views/task/task_answer'
//预览页面
import task_preview from '../views/task/task_preview'
//作业批改结果页面
import task_result from '../views/task/task_result'
//人工智能学院课程
import Aicourse from "../views/Aicourse/Aicourse"
//商学院
import SchoolBusiness from "../views/SchoolBusiness/SchoolBusiness"
//第三方登陆绑定
import thirdAccountBind from "../views/public/thirdAccountBind"
//搜索页面
import search from "../views/search/search.vue"
//操作说明
import manual_zh from "../views/index/manual_zh"
//操作说明
import manual_ja from "../views/index/manual_ja"
//操作说明
import manual_en from "../views/index/manual_en"
//操作说明
import manual_vi from "../views/index/manual_vi"
//日文 隐私保护
import policy_ja from "../views/index/policy_ja"
//中文 隐私保护
import policy_zh from "../views/index/policy_zh"
//英文 隐私保护
import policy_en from "../views/index/policy_en"
//越南语 隐私保护
import policy_vi from "../views/index/policy_vi"
//日文 服务条款
import protocol_ja from "../views/index/protocol_ja"
//中文 服务条款
import protocol_zh from "../views/index/protocol_zh"
//英文 服务条款
import protocol_en from "../views/index/protocol_en"
//越南语 服务条款
import protocol_vi from "../views/index/protocol_vi"
//日文 常见问题
import faq_ja_new from "../views/index/faq_ja_new"
//中文 常见问题
import faq_zh_new from "../views/index/faq_zh_new"
//英文 常见问题
import faq_en_new from "../views/index/faq_en_new"
//越南语 常见问题
import faq_vi_new from "../views/index/faq_vi_new"
//输入邮箱
import email from "../views/index/email"
//学习进度统计
import courseProgress from "../views/learnanalysis/courseProgress"
//课程成绩统计
import courseScoreStatistics from "../views/courseScoreStatistics/scoreStatistics"
//计划课程成绩统计
import schCourseScoreStatistics from "../views/courseScoreStatistics/schScoreStatistics"
//课程成绩
import scoreStatistics from "../views/courseScoreStatistics/courseScoreStatistics"
//移动端课程成绩
import mobileScoreStatistics from "../views/courseScoreStatistics/mobileScoreStatistics.vue"
//调查问卷
import questionnaire from "../views/exam/questionnaire"
//保证书
import covenant from "../views/exam/covenant"
//保证书预览
import covenantPreview from "../views/exam/covenantPreview"
//错题本
import wrongBook from "../views/exam/wrongBook"
//学员学习情况统计
import studySituationList from "../views/studysituation/studySituationList"
//学员学习情况统计计划
import schStudySituationList from "../views/studysituation/schStudySituationList"
//课程学习进度统计
import courProgress from "../views/exam/courseProgress"
//直播教学
import liveLesson from "../views/exam/liveLesson"
//考试记录
import examRecord from "../views/exam/examRecord"
//更多
import moreCourses from '../views/index/moreCourses'
import setSelfMenu from '../views/curriculum/setSelfMenu'
//用户协议
import userProtocol from "../views/index/userProtocol"

//学员学习情况统计
import learnProgressList from "../views/Aicourse/learnProgressList"
// manageLessons
import lessons from "@/views/manage/lessons"
// manageStudents
import students from "@/views/manage/students"
// live course
import liveCourse from "@/views/live/course"
// manage task_result_manage
import task_result_manage from "@/components/manage/task_result_manage"
// confirm Mid-term
import exam_mid_term from '../views/exam/examMidterm'
// begin wrongbook
import wrongbook_begin from '../views/exam/wrongbookBegin'
// list exambook
import examBook from '../views/exam/examBook'
//preview course
import preview from '../views/exam/preview'
// comments
import comments from "@/components/comments/list"
// manage attendances
import attendances from "@/views/manage/attendances"
// congratulation
import congratulation from "@/components/congratulations/congratulation"
// sell Course
import selfCourse from "@/views/defineSelfCourse/selfCourse"
// details self Course
import detailsSelfCourse from "@/views/defineSelfCourse/detailsSelfCourse"
// subscribe self Course
import subscribeSelfCourse from "@/views/defineSelfCourse/subscribeSelfCourse"
// subscribe Success self Course
import subscribeSuccessSelfCourse from "@/views/defineSelfCourse/subscribeSuccessSelfCourse"
//contract
import contract_new from "../views/index/contract_new"
//exchange
import exchange from "../views/index/exchange"
//faq
import faq_ja from "../views/index/faq_ja"
import faq_zh from "../views/index/faq_zh"
import faq_en from "../views/index/faq_en"
import faq_vi from "../views/index/faq_vi"
import err from "../views/index/err"
/// manual
import manual from "../views/index/manual"
/// manual
import faq_new from "../views/index/faq_new"
// SchoolBussiness
import SchoolBusiness_new from "../views/SchoolBusiness/SchoolBusiness_new"

//Schedule
// 人工智能学院课程
import schedule_aicourse from '../views/schedule/scheduleAicourse'
//课程
import schedule_curriculum from '../views/schedule/scheduleCurriculum'
//作业界面
import schedule_task_answer from '../views/schedule/schedule_task_answer'
//作业批改结果页面
import schedule_task_result from '../views/schedule/schedule_task_result'
//考试开始页面,结课测试
import scheduleExamBegins from '../views/schedule/scheduleExamBegins'
//考试页面
import scheduleTestPage from "../views/schedule/scheduleTestPage"
//课程成绩
import scheduleCourseScoreStatistics from "../views/schedule/scheduleCourseScoreStatistics"
//考试记录
import scheduleExamRecord from "../views/schedule/scheduleExamRecord"
// begin wrongbook
import schedule_wrongbook_begin from '../views/schedule/scheduleWrongbookBegin'
//错题本
import scheduleWrongbook from "../views/schedule/scheduleWrongbook"
//课程播放(视频课程/阅读课程)
import scheduleLesson from '../views/schedule/scheduleLesson'
import scheduleSetSelfMenu from '../views/schedule/scheduleSetSelfMenu'
//商学院
import scheduleSchoolBusiness from "../views/schedule/scheduleSchoolBusiness"
//保证书
import scheduleCovenant from "../views/schedule/scheduleCovenant"
// 期中考试
import scheduleExamMidterm from '../views/schedule/scheduleExamMidterm'
// congratulation
import scheduleCongratulation from "@/components/schedule/congratulation"
// curriculum exam
import curriculumExam from "@/views/curriculum/curriculumExam"
// detail exam
import examDetail from '../views/exam/detailExam'
// error api
import errApi from '@/views/index/errApi'
Vue.use(Router)

// export default new Router({
const router = new Router({
  // mode: 'history',

  routes: [
    //第三方登陆绑定
    {
      path: "/thirdAccountBind",
      component: thirdAccountBind
    },
    //试题预览界面
    {
      path: '/task/preview',
      component: task_preview
    },
    //保证书预览界面
    {
      path: '/exam/covenantPreview',
      component: covenantPreview
    },
    {
      path: '/home',
      component: home,
      children: [
        //首页
        {
          path: 'index',
          component: index
        },
        //设置界面
        {
          path: 'personSet',
          component: personSet
        },
        //购买成功
        {
          path: 'buySucess',
          component: buySucess
        },
        //重置密码
        {
          path: 'resPassword',
          component: resPassword
        },
        //联系我们
        {
          path: 'contactUs',
          component: contactUs
        },
        //error
        {
          path: 'error',
          component: error
        },
        {
          path: 'err',
          component: err
        },
        //课程
        {
          path: 'curriculum',
          component: curriculum
        },
        //考试开始，结课测试
        {
          path: 'exam/begins',
          component: exam_begins
        },
        {
          path: 'exam/detailExam',
          component: examDetail
        },
        //考试页面
        {
          path: 'testPage',
          component: testPage
        },
        //注册成功发送邮件
        {
          path: 'register_email',
          component: register_email
        },
        //课程播放(视频课程/阅读课程)
        {
          path: 'curriculum/lesson',
          component: curriculum_lesson
        },
        //作业界面
        {
          path: 'task/answer',
          component: task_answer
        },
				//作业批改结果界面
				{
				  path: 'task/result',
				  component: task_result
				},
        //管理员学习进度确认
        {
          path: "learnProgressList",
          component: learnProgressList
        },
        //人工智能学院课程
        {
          path: "Aicourse",
          name: 'Aicourse',
          component: Aicourse
        },
        //商学院
        {
          path: "SchoolBusiness",
          component: SchoolBusiness
        },
        //搜索页面
        {
          path: "search",
          component: search
        },
        //
        {
          path: 'contract_new',
          component: contract_new
        },
        //
        {
          path: 'exchange',
          component: exchange
        },
        //操作说明
        {
          path: "manual_zh",
          component: manual_zh
        },
        //操作说明
        {
          path: "manual_ja",
          component: manual_ja
        },
        //操作说明
        {
          path: "manual_en",
          component: manual_en
        },
        //操作说明
        {
          path: "manual_vi",
          component: manual_vi
        },
        /// manual
        {
          path: "manual",
          component: manual
        },
        {
          path: "faq_new",
          component: faq_new
        },
        //日文隐私保护
        {
          path: "policy_ja",
          component: policy_ja
        },
        //中文隐私保护
        {
          path: "policy_zh",
          component: policy_zh
        },
        //英文隐私保护
        {
          path: "policy_en",
          component: policy_en
        },
        //越南语隐私保护
        {
          path: "policy_vi",
          component: policy_vi
        },
        //日文服务条款
        {
          path: "protocol_ja",
          component: protocol_ja
        },
        //中文服务条款
        {
          path: "protocol_zh",
          component: protocol_zh
        },
        //英文服务条款
        {
          path: "protocol_en",
          component: protocol_en
        },
        //越南服务条款
        {
          path: "protocol_vi",
          component: protocol_vi
        },
        //日文常见问题
        {
          path: "faq_ja_new",
          component: faq_ja_new
        },
        // 中文常见问题                   
        {
          path: "faq_zh_new",
          component: faq_zh_new
        },
        //英文常见问题
        {
          path: "faq_en_new",
          component: faq_en_new
        },
        //越南语常见问题
        {
          path: "faq_vi_new",
          component: faq_vi_new
        },
        //输入邮件
        {
          path: "email",
          component: email
        },
        {
          path: "/home",
          redirect: "/home/index"
        },
        //问卷调查
        {
          path: 'exam/questionnaire',
          component: questionnaire
        },
        //保证书
        {
          path: 'exam/covenant',
          component: covenant
        },
        {
          path: 'exam/scoreStatistics',
          component: scoreStatistics
        },
        //错题本
        {
          path: 'exam/wrongBook',
          component: wrongBook
        },
        {
          path: 'exam/examBook',
          component: examBook
        },  

        //课程成绩统计
        {
          path: 'courseScoreStatistics',
          component: courseScoreStatistics
        },
        //计划课程成绩统计
        {
          path: 'schCourseScoreStatistics',
          component: schCourseScoreStatistics
        },
        //学习进度统计
        {
          path: 'courseProgress',
          component: courseProgress
        },
        //学员学习情况统计
        {
          path: 'studySituationList',
          component: studySituationList
        },
        //学员学习情况统计计划
        {
          path: 'schStudySituationList',
          component: schStudySituationList
        },
        //课程学习进度统计
        {
          path: 'exam/courseProgress',
          component: courProgress
        },
        //考试记录
        {
          path: 'exam/examRecord',
          component: examRecord
        },
        //直播教学
        {
          path: 'exam/liveLesson',
          component: liveLesson
        },
        //首页更多课程
        {
          path: 'moreCourses',
          component: moreCourses
        },
        {
          path: 'setSelfMenu',
          component: setSelfMenu
        },
        {
          path: 'manage/lessons',
          component: lessons
        },
        {
          path: 'manage/students',
          component: students
        },
        {
          path: 'live/course',
          component: liveCourse
        },
        {
          path: 'manage/students/task/result',
          component: task_result_manage
        },
        {
          path: 'exam/mid_term',
          component: exam_mid_term
        },
        {
          path: 'exam/wrongbookBegin',
          component: wrongbook_begin
        },
        {
          path: 'exam/preview',
          component: preview
        },
        {
          path: 'comment/list',
          component: comments
        },
        {
          path: 'manage/attendances',
          component: attendances
        },
        {
          path: 'schedule/schedule_aicourse',
          name: 'schedule/schedule_aicourse',
          component: schedule_aicourse
        },
        {
          path: 'schedule/schedule_curriculum',
          component: schedule_curriculum
        },
        //作业界面
        {
          path: 'schedule/schedule_task_answer',
          component: schedule_task_answer
        },
        //作业批改结果界面
        {
          path: 'schedule/schedule_task_result',
          component: schedule_task_result
        },
        //考试开始，结课测试
        {
          path: 'schedule/scheduleExamBegins',
          component: scheduleExamBegins
        },
        //考试页面
        {
          path: 'schedule/scheduleTestPage',
          component: scheduleTestPage
        },
        {
          path: 'schedule/scheduleCourseScoreStatistics',
          component: scheduleCourseScoreStatistics
        },
        //考试记录
        {
          path: 'schedule/scheduleExamRecord',
          component: scheduleExamRecord
        },
        {
          path: 'schedule/scheduleWrongbookBegin',
          component: schedule_wrongbook_begin
        },
        //错题本
        {
          path: 'schedule/scheduleWrongbook',
          component: scheduleWrongbook
        },
        //课程播放(视频课程/阅读课程)
        {
          path: 'scheduleLesson',
          component: scheduleLesson
        },
        {
          path: 'scheduleSetSelfMenu',
          component: scheduleSetSelfMenu
        },
        //我的课程
        {
          path: "scheduleSchoolBusiness",
          component: scheduleSchoolBusiness
        },
        //保证书
        {
          path: "schedule/scheduleCovenant",
          component: scheduleCovenant
        },
        //期中考试
        {
          path: "schedule/scheduleExamMidterm",
          component: scheduleExamMidterm
        },
        {
          path: "scheduleCongratulation",
          component: scheduleCongratulation
        },
        {
          path: "congratulation",
          component: congratulation
        },
        {
          path: "selfCourse",
          component: selfCourse
        },
        {
          path: "detailsSelfCourse",
          component: detailsSelfCourse
        },
        {
          path: "subscribeSelfCourse",
          component: subscribeSelfCourse
        },
        {
          path: "subscribeSuccessSelfCourse",
          component: subscribeSuccessSelfCourse
        },
        {
          path: "SchoolBusiness_new",
          component: SchoolBusiness_new
        },
        {
          path: "curriculumExam",
          component: curriculumExam
        },
        {
          path: "errApi",
          component: errApi
        }
      ]
    },
    {
      path: '/userProtocol',
      component: userProtocol
    },
    {
      path: '/mobileScoreStatistics',
      component: mobileScoreStatistics
    },
    {
      path: '/faq_ja',
      component: faq_ja
    },
    {
      path: '/faq_en',
      component: faq_en
    },
    {
      path: '/faq_vi',
      component: faq_vi
    },
    {
      path: '/faq_zh',
      component: faq_zh
    },
    {
      path: '',
      redirect: '/home' //匹配所有路径，进行路由重定向
    },
  ],

});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js